import service from "@/store/services/auction-fees-service";

export const state = () => ({
  list: {},
  auctionFee: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, auctionFee) => {
    state.auctionFee = auctionFee;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((auctionFee) => {
      commit("SET_RESOURCE", auctionFee);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((auctionFee) => {
      commit("SET_RESOURCE", auctionFee);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((auctionFee) => {
      commit("SET_RESOURCE", auctionFee);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  auctionFee: (state) => state.auctionFee,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((auctionFee) => ({
      id: auctionFee.id,
    }));
  },
};

const auctionFees = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default auctionFees;
